// Primitives shared by the promo domain (#23521). They reproduce the legacy helpers the promo rules were written
// against (m.eagle `numHelper`, `dateHelper`), so the ported rules keep the exact same edge-case behaviour.
// Every function accepts objects coming from the iframe realm: no `instanceof Array` / `instanceof Date`.

export const asArray = (value) => (Array.isArray(value) ? value : []);

/** `numHelper.sum` : plain `+` reduction, so an `undefined` entry yields NaN exactly like the legacy did. */
export function legacySum(values) {
	const list = asArray(values);
	if (!list.length) return 0;
	return list.map((item) => (typeof item?.value === 'number' ? item.value : item)).reduce((acc, value) => acc + value);
}

/** `numHelper.round2` */
export const round2 = (value) => Math.round(value * 100) / 100;

export const sumOf = (rows, field) => legacySum(asArray(rows).map((row) => row?.[field]));

/** A date is usable only if it parses : '' / null / undefined / Invalid Date are all "no date" (lesson 98). */
export function isRealDate(value) {
	if (!value) return false;
	const date = typeof value.getFullYear === 'function' ? value : new Date(value);
	return !isNaN(date.getTime());
}

export function toDate(value) {
	if (!isRealDate(value)) return null;
	return typeof value.getFullYear === 'function' ? new Date(value.getTime()) : new Date(value);
}

const dayOf = (value) => {
	const date = typeof value.getFullYear === 'function' ? value : new Date(value);
	return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

/** `dateHelper.isDateGreater` : day precision, false as soon as one side is missing or invalid. */
export function isDateGreater(d1, d2, equal = false) {
	if (!d1 || !d2) return false;
	const a = dayOf(d1);
	const b = dayOf(d2);
	return equal ? a >= b : a > b;
}

/** `dateHelper.isDateLess` : day precision, false as soon as one side is missing or invalid. */
export function isDateLess(d1, d2, equal = false) {
	if (!d1 || !d2) return false;
	const a = dayOf(d1);
	const b = dayOf(d2);
	return equal ? a <= b : a < b;
}

export function addDays(value, days) {
	const date = dayOf(value);
	date.setDate(date.getDate() + days);
	return date;
}

/** `yyyy-mm-dd` in local time, the value format of an `<input type="date">`. */
export function toInputDate(value) {
	if (!isRealDate(value)) return '';
	const date = typeof value.getFullYear === 'function' ? value : new Date(value);
	const pad = (n) => String(n).padStart(2, '0');
	return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

/** `sfaHelper.campaign.getStatementEndDate` (#23445) : the statement end date pushes the store end date back, never forward. */
export function getStatementEndDate(storeEndDate, offerInfo) {
	const statementEndDate = offerInfo?.statementEndDate;
	if (!isRealDate(statementEndDate)) return storeEndDate;
	return storeEndDate && !isDateGreater(statementEndDate, storeEndDate) ? storeEndDate : statementEndDate;
}
